import { getQueryParams } from "app/pages/industry-analysis/common/getQueryParams";
import { DefaultFetchService } from "app/services/fetchService";

import type { IRawData } from "./types";

const ENDPOINT = "api/Industries/Benchmark/Table";

export const fetchData = (): Promise<IRawData> => {
    const fetchService = DefaultFetchService.getInstance();
    const baseQueryParams = getQueryParams();
    const rawDataPromise = fetchService.get<IRawData>(ENDPOINT, baseQueryParams);
    return rawDataPromise;
};
